import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStepIncomplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    strokeWidth={1.5}
    stroke="currentColor"
    aria-hidden="true"
    width="100%"
    height="100%"
    {...props}
  >
    <path d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8Z" />
    <circle cx={8} cy={8} r={4} fill="#CFD4DE" />
  </svg>
);
export default SvgStepIncomplete;
